export const hipMoveText = {
  values: [
    { value: 'HipMove', text: 'Ja', score: 1 },
    { value: 'HipMove', text: 'Nei', score: 0 },
  ],
};
